<template>
<div class="chapter">
<div class="inner_page">
<h2 class="h2" id="ch00_fm07_note"><a id="page_15"></a><strong>Publisher’s Note</strong></h2>
<p class="indent1">This book is not intended as a substitute for medical advice. Readers are encouraged to consult with a doctor before following this or any other dietary advice.<a id="page_16"></a></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch00_fm07_note.vue?7f6e6d4d